/**
 * @generated SignedSource<<774982c9462a264b32e77974c48639d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type backupsPage_Query$variables = Record<PropertyKey, never>;
export type backupsPage_Query$data = {
  readonly configBackups: ReadonlyArray<{
    readonly byteSize: number | null | undefined;
    readonly createdAt: any;
    readonly downloadPath: string | null | undefined;
    readonly filename: string;
    readonly id: string;
    readonly ruleCount: number | null | undefined;
    readonly stakeholderCount: number | null | undefined;
    readonly takenBy: string | null | undefined;
  }>;
};
export type backupsPage_Query = {
  response: backupsPage_Query$data;
  variables: backupsPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConfigBackup",
    "kind": "LinkedField",
    "name": "configBackups",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "filename",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "byteSize",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stakeholderCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ruleCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "takenBy",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "downloadPath",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "backupsPage_Query",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "backupsPage_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "7c4657cbbb0ef1afc912d2339e86ec4e",
    "id": null,
    "metadata": {},
    "name": "backupsPage_Query",
    "operationKind": "query",
    "text": "query backupsPage_Query {\n  configBackups {\n    id\n    filename\n    byteSize\n    stakeholderCount\n    ruleCount\n    takenBy\n    createdAt\n    downloadPath\n  }\n}\n"
  }
};
})();

(node as any).hash = "50b702d77664eac59dcab976a7d2ca4e";

export default node;
